import { TrainingEmailEventTypes } from './training.email.event.types';

export class PreviewEmailsForTrainingEventRequest {
    TrainingEventID: number;
    TrainingEmailEventType: TrainingEmailEventTypes;
}
